// @flow
export { default } from './ProductsTagsTemplate';



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagsTemplate/index.js